import CloseCircle from '../../assets/img/close-circle-bold.svg';
import TickCircle from '../../assets/img/tick-circle-bold.svg';
import CompanyLogo from '../CompanyLogo/CompanyLogo';

import styles from './CompanyLogoCheckmark.module.scss';

type Props = {
  isCancel?: boolean;
  logo?: string;
  url?: string;
  symbol?: string;
};

const CompanyLogoCheckmark = ({ logo, url, isCancel, symbol }: Props): JSX.Element => (
  <div className={styles.symbolLogoWrapper}>
    <img src={isCancel ? CloseCircle : TickCircle} alt={isCancel ? 'rejected order' : 'check success'} className={styles.icon} />
    <CompanyLogo url={url} logo={logo} className={styles.logo} symbol={symbol} />
  </div>
);

export default CompanyLogoCheckmark;
